import { render, staticRenderFns } from "./ProductInfoLook.vue?vue&type=template&id=08faa05a&scoped=true&"
import script from "./ProductInfoLook.vue?vue&type=script&lang=js&"
export * from "./ProductInfoLook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08faa05a",
  null
  
)

export default component.exports